import styled from '@emotion/styled';
import React, { forwardRef } from 'react';
import { isNumericText, isRejectedNumericKey } from 'shared/utils';

/**
 * The `<input type="number">` every inspector field is built on still accepts
 * the letters `e`/`E` (scientific notation) and a leading `+`, and then reports
 * an empty value for the whole field — so the input shows letters the state
 * never sees and the edit silently does nothing. Filtering keystrokes and
 * pastes here keeps every numeric field digits-only in one place.
 */
const NumericInput = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ onKeyDown, onPaste, ...rest }, ref) => (
    <Input
      {...rest}
      ref={ref}
      type="number"
      onKeyDown={(e) => {
        if (isRejectedNumericKey(e)) e.preventDefault();
        onKeyDown?.(e);
      }}
      onPaste={(e) => {
        if (!isNumericText(e.clipboardData?.getData('text') ?? '')) e.preventDefault();
        onPaste?.(e);
      }}
    />
  ),
);

NumericInput.displayName = 'NumericInput';

export default NumericInput;

const Input = styled.input`
  width: 100%;
  min-width: 0;
  padding: 4px 6px;
  font-size: 13px;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #ffffff;
  outline: none;

  &:focus {
    border-color: #9ca3af;
  }
`;
